import {tgxApi} from "../../app/tgxApi";
import {serialize} from "../../helpers/utils/Utils";
import {
    getAuthorizationHeader,
    handleQueryError,
    handleQueryErrorAndSuccess
} from "../../helpers/utils/RtkQueryUtils";

export const branchApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({

        getBranchesForCustomer: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/ajax/get-customer-branches?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['branches'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),

        getBranchesByCustomerIds: build.query({
            query: (customerIds) => {
                // Serialize the data to query parameters
                let paramData = serialize({customerIds: customerIds});
                return {
                    url: `/ajax/branches-by-customer-ids?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),

        getBranchById: build.query({
            query: ({customerId,branchId}) => {
                return {
                    url: `/ajax/get-branch-by-id/${customerId}/${branchId}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
            providesTags:["branchById"]
        }),

        createBranch: build.mutation({
            query: ({customerId, requestBody}) => {
                return {
                    url: `/ajax/createBranch`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['branches'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Created", "Branch");
            },
        }),

        updateBranch: build.mutation({
            query: ({customerId, branchId, requestBody}) => {
                return {
                    url: `/ajax/updateBranch`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['branches','branchById'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Branch");
            },
        }),
        deleteBranchByBranchId: build.mutation({
            query: ({customerId,branchId}) => {
                return {
                    url: `/ajax/delete-by-branch-id/${customerId}/${branchId}`,
                    method: 'DELETE',
                    headers: getAuthorizationHeader()
                };
            },
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Deleted", "Branch Detail");
            },
        }),
    })
})

export const {
    useGetBranchByIdQuery,
    useLazyGetBranchByIdQuery,
    useGetBranchesForCustomerQuery,
    useLazyGetBranchesForCustomerQuery,
    useCreateBranchMutation,
    useUpdateBranchMutation,
    useGetBranchesByCustomerIdsQuery,
    useDeleteBranchByBranchIdMutation
} = branchApi